import * as types from './types';

export function userLogin(payload, cb) {
  return {
    type: types.LOGIN,
    payload,
    cb,
  };
}
